import { render, staticRenderFns } from "./KasallikTarixi.vue?vue&type=template&id=4f2a6537"
import script from "./KasallikTarixi.vue?vue&type=script&lang=js"
export * from "./KasallikTarixi.vue?vue&type=script&lang=js"
import style0 from "./KasallikTarixi.vue?vue&type=style&index=0&id=4f2a6537&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports